$(document).ready(function () {
    $(".product-slider").slick({
        arrows: true,
        loop: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".discover-slider").slick({
        arrows: true,
        loop: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    cenerPadding: "10px 0",
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    cenerPadding: "10px 0",
                },
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "120px 0",
                },
            },
        ],
    });

    $(".deals-slider").slick({
        arrows: true,
        loop: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "40px 0 0",
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "40px 0 0",
                },
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "10px 0 0",
                },
            },
        ],
    });

    $(".usp-slider").slick({
        arrows: false,
        loop: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    arrows: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "40%",
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "40%",
                },
            },
        ],
    });

    $(".related-product-slider").slick({
        arrows: true,
        loop: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 389,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "10% 0",
                },
            },
        ],
    });

    $(".slider-for").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        asNavFor: ".slider-nav",
    });
    $(".slider-nav").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        asNavFor: ".slider-for",
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    cenerPadding: "10% 0",
                    vertical: false,
                    verticalSwiping: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    centerMode: true,
                    cenerPadding: "20% 0",
                    vertical: false,
                    verticalSwiping: false,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    cenerPadding: "20% 0",
                    vertical: false,
                    verticalSwiping: false,
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    cenerPadding: "20% 0",
                    vertical: false,
                    verticalSwiping: false,
                },
            },
            {
                breakpoint: 389,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    cenerPadding: "80px 0",
                    vertical: false,
                    verticalSwiping: false,
                },
            },
        ],
    });
    $(".blog-slider").slick({
        arrows: true,
        loop: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 390,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".description-block .btn-secondary").click(function () {
        var $this = $(this);
        var $detail = $(".description-block .detail");

        $detail.toggleClass("show");
        $this.toggleClass("show");

        if ($this.text().includes("Toon meer")) {
            $this.html('Toon minder <i class="fas fa-chevron-up"></i>');
        } else {
            $this.html('Toon meer <i class="fas fa-chevron-down"></i>');
        }
    });

    $(".product-wrpper .btn-filter").click(function () {
        $(".filter-sidebar").toggleClass("show");
    });
    $(".template-search .btn-filter").click(function () {
        $(".filter-sidebar").toggleClass("show");
    });

    $(".product-wrpper .close-btn").click(function () {
        $(".filter-sidebar").removeClass("show");
    });
    $(".template-search .close-btn").click(function () {
        $(".filter-sidebar").removeClass("show");
    });
});

(function ($) {
    "use strict";
    $(document).ready(function () {
        $(".product-detail-block .slider-for .slick-list.draggable").on(
            "click",
            function () {
                var data_media_id = $(this)
                    .find(".slick-slide.slick-current.slick-active .currentImg")
                    .attr("data-media-id");
                $("body").addClass("modal-open");
                setTimeout(function () {
                    var position = $(
                        '#custom-modal .custom-modal-inner img[data-media-id="' +
                        data_media_id +
                        '"]',
                    ).position().top;
                    $("#custom-modal").animate(
                        {
                            scrollTop: position,
                        },
                        10,
                    );
                }, 500);
            },
        );
        $(".close-modal").on("click", function () {
            $("body").removeClass("modal-open");
        });
    });
})(jQuery);
